import { getHomeTabs } from './getHomeTabs';
import { getHomeIcons } from './getHomeIcons';

export const homeService = {
  getHomeTabs,
  getHomeIcons,
};
